var map = {
	"./LogoPMS.png": "e78A",
	"./LogoXs.jpg": "ZDE/",
	"./SshdLogo.png": "y0j6",
	"./brasao-pms.png": "8ZOn",
	"./centralservidor-logo-texto.png": "VQf9",
	"./centralservidor-logo.png": "d1MV",
	"./favicon.ico": "43FW",
	"./ico-contagem.png": "lIAz",
	"./ico-ferias.png": "u1pV",
	"./ico-holerites.png": "9TPg",
	"./ico-ocorrencias.png": "A0xF",
	"./ico-previdenciario.png": "mLKy",
	"./textura-papel-reciclado.jpg": "v6Um"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 5